if (!window.TdJudgeMeTrigger) {
  window.TdJudgeMeTrigger = (function () {
    const PROXY_TARGETS = [
      '.jdgm-prev-badge__stars',
      '.jdgm-prev-badge__text',
      '.jdgm-prev-badge',
      'a[href="#judgeme_product_reviews"]',
    ];

    function openFloatingTab() {
      const el = document.querySelector('.jdgm-revs-tab-btn');
      if (!el) return false;
      el.click();
      return true;
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-lp-review-popup-trigger]');
      if (!trigger) return;

      event.preventDefault();
      const proxyId = trigger.getAttribute('data-lp-review-popup-trigger');
      if (!proxyId) return;

      if (openFloatingTab()) return;

      const proxy = document.querySelector(`[data-lp-review-proxy="${proxyId}"]`);
      if (!proxy) return;

      for (const selector of PROXY_TARGETS) {
        const target = proxy.querySelector(selector);
        if (target) { target.click(); return; }
      }
      proxy.click();
    });

    return { openFloatingTab };
  })();
}
